import { Palette } from '@/themes/themeOverrides/Palette';

export const summaryStepChipStyles = {
    primary: {
        backgroundColor: Palette.white,
        fontWeight: 600,
        height: '36px',
        borderRadius: '12px',
        '& .MuiChip-label': {
            fontSize: '14px',
        },
    },
    secondary: {
        backgroundColor: Palette.gray.gray200,
        color: Palette.gray.gray700,
        height: '36px',
        borderRadius: '12px',
        '& .MuiChip-label': {
            fontSize: '14px',
        },
    },
    small: {
        backgroundColor: Palette.white,
        height: '28px',
        borderRadius: '12px',
        '& .MuiChip-label': {
            fontSize: '14px',
        },
    },
    sponsored: {
        backgroundColor: Palette.violet.violet100,
        height: '28px',
        borderRadius: '12px',
        '& .MuiChip-label': {
            fontSize: '14px',
        },
    },
};

export const summaryStepContainerStyles = {
    productCard: {
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        padding: '16px',
        borderRadius: '16px',
        backgroundColor: Palette.white,
    },
    imageContainer: {
        flexShrink: 0,
        padding: '6px',
        borderRadius: '8px',
        border: `2px solid ${Palette.gray.gray100}`,
    },
    imageContainerLarge: {
        flexShrink: 0,
        borderRadius: '8px',
        border: `2px solid ${Palette.gray.gray100}`,
    },
    contentContainer: {
        flex: 1,
        minWidth: 0,
    },
};

export const summaryStepTypographyStyles = {
    productName: {
        fontSize: '14px',
        color: Palette.black,
    },
    productEan: {
        color: Palette.gray.gray600,
        fontSize: '11px',
    },
    description: {
        fontSize: '14px',
        color: Palette.black,
    },
};

export const summaryStepImageStyles = {
    productImage: {
        '& .RaImageField-image': {
            width: '76px',
            height: '76px',
            margin: '0',
        },
    },
    couponImage: {
        '& .RaImageField-image': {
            width: '88px',
            height: '88px',
            margin: '0',
            objectFit: 'cover',
            borderRadius: '4px',
        },
    },
    noImage: {
        width: '64px',
        height: '64px',
    },
};

export const summaryStepLayoutStyles = {
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    flexRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        alignItems: 'center',
    },
    flexRowBaseline: {
        display: 'flex',
        alignItems: 'baseline',
        gap: '4px',
        flexWrap: 'wrap',
    },
    criteriaGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
    },
    criteriaSubgroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    criteriaRows: {
        backgroundColor: Palette.white,
        fontSize: '11px',
        padding: '8px 12px',
        borderRadius: '12px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'baseline',
        gap: '4px',
    },
};
